import type { Component } from 'vue'

import type { PreviewContentType } from '@/store/preview/types'

import RendererHtml from './RendererHtml.vue'
import RendererMermaid from './RendererMermaid.vue'
import RendererPdf from './RendererPdf.vue'
import RendererPowerpoint from './RendererPowerpoint.vue'
import RendererXlsx from './RendererXlsx.vue'

const rendererRegistry: Record<PreviewContentType, Component> = {
  html: RendererHtml,
  mermaid: RendererMermaid,
  spreadsheet: RendererXlsx,
  powerpoint: RendererPowerpoint,
  pdf: RendererPdf,
}

export function getRenderer(
  type: PreviewContentType | undefined,
): Component | null {
  if (type === undefined) return null
  return rendererRegistry[type] ?? null
}

export function hasRenderer(type: PreviewContentType | undefined): boolean {
  if (type === undefined) return false
  return rendererRegistry[type] != null
}
